import React, { Component } from "react";

import { Translate } from "react-redux-i18n";

import per_kwh from "../../../styles/images/tariffType/per_kwh_unselected.svg";
import per_kwh_selected from "../../../styles/images/tariffType/per_kwh_selected.svg";
import per_time from "../../../styles/images/tariffType/per_min_unelected.svg";
import per_time_selected from "../../../styles/images/tariffType/per_min_selected.svg";

import available_only_selected from "../../../styles/images/available/available_only_selected.svg";
import available_only from "../../../styles/images/available/available_only_unselected.svg";
import online_only_selected from "../../../styles/images/available/online_only_selected.svg";
import online_only from "../../../styles/images/available/online_only_unselected.svg";

import "../../../styles/components/map/filter/AvailableFilter.scss";

class AvailableFilter extends Component {
  render() {
    return (
      <div id="available-filter">
        <div className="filter-item">
          <p>
            <Translate value="availabilityAccess_availability" />
          </p>
          <div className="available-container">
            <div
              className="available-type"
              onClick={() =>
                this.props.handleSelectTariffType("online", "availableStations")
              }
            >
              <img
                src={
                  this.props.availableStations === "online"
                    ? online_only_selected
                    : online_only
                }
                alt=""
              />
              <p>
                <Translate value="mapFilter_onlyOnline" />
              </p>
            </div>
            <div
              className="available-type"
              onClick={() =>
                this.props.handleSelectTariffType(
                  "available",
                  "availableStations"
                )
              }
            >
              <img
                src={
                  this.props.availableStations === "available"
                    ? available_only_selected
                    : available_only
                }
                alt=""
              />
              <p>
                <Translate value="mapFilter_onlyAvailable" />
              </p>
            </div>
          </div>
        </div>
        <div className="filter-item">
          <p>
            <Translate value="mapFilter_tariff" />
          </p>
          <div className="available-container">
            <div
              className="available-type"
              onClick={() =>
                this.props.handleSelectTariffType("power", "tariffType")
              }
            >
              <img
                src={
                  this.props.tariffType === "power" ? per_kwh_selected : per_kwh
                }
                alt=""
              />
              <p>€/kWh</p>
            </div>
            <div
              className="available-type"
              onClick={() =>
                this.props.handleSelectTariffType("time", "tariffType")
              }
            >
              <img
                src={
                  this.props.tariffType === "time"
                    ? per_time_selected
                    : per_time
                }
                alt=""
              />
              <p>€/min</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AvailableFilter;
